/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `Created`
};

const fr_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `Créé`
};

const de_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `Erstellt`
};

const es_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `Creado`
};

const it_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `Creato`
};

const ar_summary_details_created_at_title28 = /** @type {(inputs: {}) => string} */ () => {
	return `مخلوق`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_details_created_at_title28 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_details_created_at_title28(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_details_created_at_title28", locale)
	if (locale === "en") return en_summary_details_created_at_title28(inputs)
	if (locale === "fr") return fr_summary_details_created_at_title28(inputs)
	if (locale === "de") return de_summary_details_created_at_title28(inputs)
	if (locale === "es") return es_summary_details_created_at_title28(inputs)
	if (locale === "it") return it_summary_details_created_at_title28(inputs)
	return ar_summary_details_created_at_title28(inputs)
};
export { summary_details_created_at_title28 as "SUMMARY_DETAILS_CREATED_AT_TITLE" }